'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _delete2 = require('react-icons/lib/md/delete');

var _delete3 = _interopRequireDefault(_delete2);

var _openInBrowser = require('react-icons/lib/md/open-in-browser');

var _openInBrowser2 = _interopRequireDefault(_openInBrowser);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _cleanFileURL = require('./cleanFileURL');

var _cleanFileURL2 = _interopRequireDefault(_cleanFileURL);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = {
  container: {
    backgroundColor: '#fff',
    borderRadius: 5,
    padding: 7,
    fontSize: 18,
    color: '#000',
    display: 'flex',
    border: '1px solid #c2c2c2'
  },
  name: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1
  },
  buttons: {
    width: 70,
    textAlign: 'right'
  },
  icon: {
    marginLeft: 10,
    cursor: 'pointer'
  }
};

var Show = (_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Show, _React$Component);

  function Show() {
    (0, _classCallCheck3.default)(this, Show);
    return (0, _possibleConstructorReturn3.default)(this, (Show.__proto__ || Object.getPrototypeOf(Show)).apply(this, arguments));
  }

  (0, _createClass3.default)(Show, [{
    key: 'delete',
    value: function _delete() {
      this.props.onChange(null);
    }
  }, {
    key: 'open',
    value: function open() {
      window.open(this.props.value.url);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: styles.container },
        _react2.default.createElement(
          'div',
          { style: styles.name },
          (0, _cleanFileURL2.default)(this.props.value.url)
        ),
        _react2.default.createElement(
          'div',
          { style: styles.buttons },
          _react2.default.createElement(_openInBrowser2.default, { style: styles.icon, size: 25, onClick: this.open }),
          _react2.default.createElement(_delete3.default, { style: styles.icon, size: 25, onClick: this.delete })
        )
      );
    }
  }]);
  return Show;
}(_react2.default.Component), _class2.propTypes = {
  value: _propTypes2.default.object,
  onChange: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'delete', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'delete'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'open', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'open'), _class.prototype)), _class);
exports.default = Show;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/fields/File/Show.js
// module id = 2581
// module chunks = 0